import Joi from 'joi';
import { isNullOrWhitespace } from '../../../utils/stringExtensions';

const UserLicenseInformationInputValidator = {
  validateUserData: input => {
    const schema = Joi.object({
      externalUserId: Joi.number().min(0).required(),
      email: Joi.string().required(),
      firstName: Joi.string().required().custom(validateStringInput),
      lastName: Joi.string().required().custom(validateStringInput),
      selectedRole: Joi.number().required()
    });

    return schema.validate(input, { abortEarly: true });
  }
};

const validateStringInput = value => {
  if (isNullOrWhitespace(value)) {
    throw Error('value must not be an empty string.');
  }

  return value;
};

export default UserLicenseInformationInputValidator;
